import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  startIntroAnim = "START_INTRODUCTION_ANIMATION",
  drawElements = "DRAW_ELEMENTS",
  setSltdTPIndex = "SET_SELECTED_TANGENT_POINT_INDEX",
  genRndmTriangle = "GENERATE_RANDOM_TRIANGLE",
  quasimodoMode = "QUASIMODO_MODE",
  moveTangentPoint = "MOVE_TANGENT_POINT",
  moveAllPoints = "MOVE_ALL_POINTS",
  setRefPoints = "SET_REF_POINTS"
}

export const EventBus = new EventEmitter();